export default __webpack_public_path__ + "static/media/HighFive.66810b80.png";